<template>
  <div class="MoreProgram" style="margin-top: 100px">
    <!-- Container -->
    <div
      class="container"
      v-loading="ploading"
      element-loading-background="transparent"
    >
      <!-- 我們的節目 -->
      <section id="programme-list" class="section-group">
        <h2 class="section-title"> {{ $t('Video.MoreProgram.Ourshow') }}</h2>
        <div class="section-sub">
          <div class="category">
            <el-button
              size="mini"
              :class="{ current: 0 == currenTypeId }"
              @click="GetListByType(0)"
              > {{ $t('Video.MoreProgram.All') }}</el-button
            >
            <el-button
              size="mini"
              v-for="item in GetProgramTypeList"
              :key="item.id"
              :class="{ current: item.id == currenTypeId }"
              @click="GetListByType(item.id)"
              >{{ item.sgL_Program_Name }}</el-button
            >
          </div>
          <div class="sorting right">
             {{ $t('Video.MoreProgram.order') }}&nbsp;
            <el-button
              size="mini"
              @click="orderbyhot('CreateTime')"
              :class="{ current: 'CreateTime' == selectoption }"
              > {{ $t('Video.MoreProgram.Press') }}</el-button
            >
            <el-button
              size="mini"
              @click="orderbyhot('QueriesCount')"
              :class="{ current: 'QueriesCount' == selectoption }"
              > {{ $t('Video.MoreProgram.popularity') }}</el-button
            >
          </div>
        </div>
        <div class="programme-row row">
          <div
            class="programme-card card mb-3"
            v-for="program in getProgramList"
            v-bind:key="program.id"
          >
            <router-link
              v-bind:to="{
                name: 'WatchVideo',
                params: { id: program.id, itemtype: 'program' },
              }"
            >
              <div class="programme-block">
                <div class="programme-thumbnail">
                  <div class="programme-responsive">
                    <div class="programme-sizer">
                      <div
                        class="programme-image"
                        :style="{
                          backgroundImage:
                            'url(' + `${program.sgL_LogImage}` + '),url(' + `${require('../../assets/images/404.png')}` + ')',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="programme-episode">
                    <span v-if="program.sgL_SetUpStatus == 0"
                      > {{ $t('Video.MoreProgram.Updated') }} {{ program.movieCount }}  {{ $t('Video.MoreProgram.episode') }}</span
                    >
                    <span v-else> {{ $t('Video.MoreProgram.total') }} {{ program.movieCount }}  {{ $t('Video.MoreProgram.episode') }}</span>
                  </div>
                </div>
              </div>
              <div class="programme-info p-3">
                <div class="programme-title">
                  {{ program.sgL_Program_Name }}
                </div>
                <span class="programme-intro">{{
                  program.sgL_Program_NameDesc
                }}</span>
                <span class="programme-last-updated"
                  > {{ $t('Video.MoreProgram.Lastupdated') }}{{ program.sgL_UpdateTimeH }}</span
                >
              </div>
            </router-link>
          </div>
        </div>
      </section>
      <!-- /.我們的節目 -->
    </div>
    <!-- /.Container -->
  </div>
</template>
<style>
/* @import "../../assets/css/desktop/normalize.css";
@import "../../assets/css/desktop/main.css";
@import "../../assets/css/font-awesome/all.min.css"; */
/* @import "../../assets/css/bootstrap/bootstrap-grid.css"; */
</style>
<script>
export default {
  name: "MoreProgram",
  data() {
    return {
      currenTypeId: 0, //当前的typeId，默认是查所有
      msg: "",
      ploading: true,
      selectoption: "CreateTime",
      programList: [], //节目列表数据
      typelist: [], //节目类型数据集合
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 1);
    this.GetProgramList();
    this.GetTypeList();
  },
  computed: {
    getProgramList() {
      return this.programList;
    },
    GetProgramTypeList() {
      return this.typelist;
    },
  },
  watch: {
    // programList(newvalue, oldvalue) {
    //   if (newvalue.length > 0) {
    //     this.ploading = false;
    //   } else {
    //     this.ploading = true;
    //   }
    // }
  },
  methods: {
    //查询所有节目列表
    async GetProgramList() {
      let params = {
        SGL_Program_Type: 0,
        MaxResultCount: 50,
        SGL_Program_TypeId: this.currenTypeId,
        Sorting: this.selectoption,
      };
      this.$api.VideoApi.GetPageProgramOrTypeDesk(params).then((result) => {
        this.ploading = false;
        this.programList = result.data.result.items;
      });
    },
    //排序
    async orderbyhot(current) {
      this.selectoption = current;
      this.GetProgramList();
      // let params = {
      //   SGL_Program_Type: 0,
      //   SkipCount: 0,
      //   MaxResultCount: 50,
      //   Sorting: "QueriesCount",
      // };
      // this.$api.VideoApi.GetPageProgramOrTypeDesk(params).then((result) => {
      //   this.programList = result.data.result.items;
      // });
    },
    //查询所有节目類型列表
    async GetTypeList() {
      let params = { SGL_Program_Type: 1 };
      this.$api.VideoApi.GetPageProgramOrTypeDesk(params).then((result) => {
        this.typelist = result.data.result.items;
      });
    },
    //根据节目类型查询节目列表
    GetListByType(Id) {
      this.currenTypeId = Id;
      this.GetProgramList();
      // if (Id == 0) {
      //   this.GetProgramList();
      // } else {
      //   let params = { SGL_Program_TypeId: Id };
      //   this.$api.VideoApi.getProgramListByTypeId(params).then((result) => {
      //     this.ploading = false;
      //     this.programList = result.data.result;
      //   });
      // }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Video/MoreProgram.vue